import { render } from "./Vehicle.vue?vue&type=template&id=767b78e8&ts=true"
import script from "./Vehicle.vue?vue&type=script&lang=ts"
export * from "./Vehicle.vue?vue&type=script&lang=ts"

import "./Vehicle.vue?vue&type=style&index=0&id=767b78e8&lang=scss"

import exportComponent from "/home/newbaidev/public_html/projects-sit/uae/sit-ae-car.new.baidev.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__